module.exports = __webpack_public_path__ + "assets/chevron-left-gray-121ca931b4038829b7589ce9d5eaef39.svg";